var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invites"},[_c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"welcome"},[_c('h1',[_vm._v("Untrusted Consignor Invites That Need Approving")])]),_c('approvals-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }